'use strict';
import './kgPlayer.css'
import pendant from './kgPlayer.html'
import openKugouApp from "./openKugouApp/main"
import md5 from 'md5'
import sha1 from "sha1"
import infSign from "@kugou/interface-signature"
import { getBaseInfo } from "./getBaseInfo/main"


// let domain = "https://activity.kugou.com/vo-activity/fa339ef0-2270-11ea-8b2a-c3556712becb"
let domain = "https://activity.kugou.com/vo/fa339ef0"

// let script = document.getElementsByTagName("script")
// for (var i = 0; i < script.length; i++) {
//     if (script[i].src.indexOf("kgPlayer") > -1) {
//         domain = script[i].src.split("/dist/")[0];
//         break
//     }
// }
//播放对象
let playerManager = new Audio()
//不先设置src的话，ios下没有src play（）会导致play事件不执行
playerManager.src = ""
//埋点对象
window.apmCollectData = window.apmCollectData || []
//内部对象
let protectData = {}
const resetProtectData = () => {
    protectData = {
        hideBar: false,//是否隐藏挂件
        firstShowBar: null,//是否初始化显示挂件
        barText: "",//挂件当前显示的歌曲
        hasInitPlayer: false,//是否初始化播放
        hasInitSearch: false,//是否初始化搜索
        songUrlData: null,//获取歌曲地址的接口数据
        audioInfoData: null,//获取歌曲信息的接口数据
        playerMark: null,//播放标记
        canAutoPlay: false,//是否开始自动播放
        initPlayerManager: false,
        launchApp: false,
        eventList: [],
        timerList: {}
    }
}
resetProtectData()
/**
 * 工具类
 */
const util = {
    /**
     * 请求接口
     * @param {*} url 
     * @param {*} data 
     * @param {*} options 
     */
    request: (url = '', data = {}, options = {}) => {
        let type = options.type || "GET"

        type = type.toUpperCase()
        if (type == 'GET') {
            let dataStr = '' //数据拼接字符串
            Object.keys(data).forEach(key => {
                dataStr += key + '=' + data[key] + '&'
            })

            if (dataStr !== '') {
                dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'))
                url = url + '?' + dataStr
            }
        }
        return new Promise((resolve, reject) => {
            let requestObj
            if (window.XMLHttpRequest) {
                requestObj = new XMLHttpRequest()
            } else {
                requestObj = new window.ActiveXObject
            }

            let sendData = ''
            if (type == 'POST') {
                if (options.postType == "urlencoded") {
                    for (var i in data) {
                        sendData += (i + "=" + data[i] + "&")
                    }
                    sendData = sendData.substr(0, sendData.length - 1)
                } else {
                    sendData = JSON.stringify(data)
                }
            }
            requestObj.open(type, url, true)
            if (options.headers) {
                for (var i in options.headers) {
                    requestObj.setRequestHeader(i, options.headers[i])
                }
            }
            if (type == 'POST') {
                requestObj.send(sendData)
            } else {
                requestObj.send(null)
            }
            let isTimeout = false
            let timer = null
            let sTime = new Date().getTime()
            if (options.timeout) {
                timer = setTimeout(() => {
                    isTimeout = true
                    resolve(0)
                }, options.timeout)
            }
            requestObj.onreadystatechange = () => {
                if (requestObj.readyState == 4) {
                    if (requestObj.status == 200) {
                        // if (isTimeout) {
                        //     return
                        // }
                        timer && (clearTimeout(timer))
                        let obj = requestObj.response
                        if (typeof obj !== 'object') {
                            obj = JSON.parse(obj)
                        }
                        if (isTimeout) {
                            options.timeoutCallback && options.timeoutCallback({
                                data: obj,
                                header: util.getHeader(requestObj)
                            }, {
                                url: type == 'POST' ? sendData : url,
                                time: new Date().getTime() - sTime
                            })
                        } else {
                            resolve({
                                data: obj,
                                header: util.getHeader(requestObj)
                            })
                        }
                    } else {
                        if (isTimeout) {
                            options.timeoutCallback && options.timeoutCallback(null, {
                                url: type == 'POST' ? sendData : url,
                                time: new Date().getTime() - sTime
                            })
                        } else {
                            resolve(null)
                        }
                    }
                }
            }
        })
    },
    /**
     * 具备重试机制的请求
     * @param {*} baseUrl 
     * @param {*} url 
     * @param {*} data 
     * @param {*} options 
     */
    requestByRetry: async (baseUrl = [], url = '', data = {}, options = {}) => {
        !options.headers && (options.headers = [])
        let result = await util.request(baseUrl[0] + url, data, options)
        !result && baseUrl[1] && (result = await util.request(baseUrl[1] + url, data, {
            ...options,
            headers: {
                ...options.headers,
                ...(options['headers']['x-router'] ? { 'x-router': options['headers']['x-router-backup'] || options['headers']['x-router'] } : {})
            }
        }))
        return result
    },
    /**
     * GateWay请求接口
     * @param {*} baseUrl 
     * @param {*} url 
     * @param {*} data 
     * @param {*} options 
     */
    gateWay: async (baseUrl = [], url = '', data = {}, options = {}) => {
        baseUrl = baseUrl.map(v => v.replace(/https:\/\/|http:\/\//ig, ""))
        const result = await util.requestByRetry([
            "https://gateway.kugou.com",
            "https://gatewayretry.kugou.com"
        ], url, data, {
            ...(options || {}),
            headers: {
                "Content-type": "application/json",
                'x-router': baseUrl[0],
                ...(baseUrl[1] ? { "x-router-backup": baseUrl[1] } : {})
            }
        })
        return result
    },
    gateWay2: async (baseUrl = [], url = '', data = {}, options = {}) => {
        baseUrl = baseUrl.map(v => v.replace(/https:\/\/|http:\/\//ig, "").replace(/\.kugou\.com/ig, ""))
        const result = await util.requestByRetry([
            "https://gateway.kugou.com" + (baseUrl[0] ? "/" + baseUrl[0] : ""),
            "https://gatewayretry.kugou.com" + (baseUrl[1] ? "/" + baseUrl[1] : (baseUrl[0] ? "/" + baseUrl[0] : ""))
        ].splice(0, options.noRetry ? 1 : 2), url, data, {
            ...(options || {})
        })
        return result
    },
    /**
     * 中转内部请求接口
     * @param {*} json 
     */
    interRequest: async (json = {}) => {
        if (json.options && json.options.pmTimeout) {
            json.options.timeoutCallback = function (result, option) {
                if (result) {
                    window.parent.postMessage(JSON.stringify({
                        name: "kgPlayerRequestCallParent",
                        data: {
                            data: result.data,
                            jname: json.jname || '',
                            header: result.header,
                            timeout: true,
                            option: option
                        }
                    }), '*')
                } else {
                    window.parent.postMessage(JSON.stringify({
                        name: "kgPlayerRequestCallParent",
                        data: {
                            jname: json.jname || '',
                            error: result,
                            timeout: true,
                            option: option
                        }
                    }), '*')
                }
            }
        }
        let result = await util.gateWay2(json.baseUrl || [], json.url || '', json.data || {}, json.options || {})
        if (result) {
            window.parent.postMessage(JSON.stringify({
                name: "kgPlayerRequestCallParent",
                data: {
                    data: result.data,
                    jname: json.jname || '',
                    header: result.header
                }
            }), '*')
        } else {
            window.parent.postMessage(JSON.stringify({
                name: "kgPlayerRequestCallParent",
                data: {
                    jname: json.jname || '',
                    error: result
                }
            }), '*')
        }
    },
    /**
     * 中转请求接口
     * @param {*} baseUrl 
     * @param {*} url 
     * @param {*} data 
     * @param {*} options 
     */
    transit: (baseUrl = [], url = '', data = {}, options = {}) => {
        let box = document.createElement("iframe")
        box.id = "kgPlayerRequestIframe" + Math.random().toString().substr(2, 9)
        // box.src = "http://local10001.kugou.com/request.html"
        box.src = domain + "/request.html?v=1"
        box.style.cssText = [
            "width:0",
            "height:0",
            "border:0 none",
            "display:none"
        ].join(";")
        document.body.appendChild(box)
        return new Promise((resolve, reject) => {
            let jname = "request_" + Math.random().toString().substr(2, 9)
            window[jname] = (res) => {
                if (res.timeout) {
                    if (res.data) {
                        options.timeoutCallback && options.timeoutCallback({
                            data: res.data,
                            header: res.header
                        }, res.option)
                    } else {
                        options.timeoutCallback && options.timeoutCallback(res.error, res.option)
                    }
                } else {
                    if (res.data) {
                        resolve({
                            data: res.data,
                            header: res.header
                        })
                    } else {
                        resolve(res.error)
                    }
                }
            }
            setTimeout(() => {
                document.body.removeChild(box)
                window[jname] = null
            }, 60 * 1000)
            let ele = document.getElementById(box.id)
            ele.onload = () => {
                ele.contentWindow.postMessage(JSON.stringify({
                    "name": "kgPlayerRequest",
                    "data": {
                        baseUrl, url, data, options, jname
                    }
                }), ele.src)
            }
        })
    },
    /**
     * 判断域名
     * 酷狗域名的用网关请求
     * 非酷狗域名的用中转请求
     */
    getData: async (baseUrl = [], url = '', data = {}, options = {}) => {
        if (/kugou\.com/.test(window.location.href)) {
            return await util.gateWay2(baseUrl, url, data, options)
        } else {
            return await util.transit(baseUrl, url, data, options)
        }
    },
    /**
     * 获取请求头部
     * @param {Object} XMLHttp 
     */
    getHeader: (XMLHttp) => {
        let headers = XMLHttp.getAllResponseHeaders()
        let arr = headers.split(/\r\n/)
        let obj = {}
        for (var i = 0; i < arr.length; i++) {
            if (arr[i]) {
                let kv = arr[i].split(":")
                obj[kv[0]] = kv[1].replace(/^\s+/, "")
            }
        }
        return obj
    },
    /**
     * 加载脚本
     * @param {String} url 
     * @param {Object} args 
     * @param {Function} callback 
     */
    loadScript: (url, args, callback) => {
        var params = args || ""
        if (args && (typeof args === "object")) {
            var str = ""
            for (var i in args) {
                str += i + "=" + args[i] + "&"
            }
            params = str.substr(0, str.length - 1)
        }
        params = params.trim()
        var script = document.createElement("script")
        script.type = 'text/javascript'
        if (script.readyState) {
            script.onreadystatechange = function () {
                if (this.readyState == "complete" || this.readyState == "loaded") {
                    callback && callback()
                    script.onreadystatechange = script = callback = null
                }
            }
        } else {
            script.onload = () => {
                callback && callback()
                script.onload = script = callback = null
            }
        }
        script.src = url + (params ? "?" + params : "")
        document.getElementsByTagName("head")[0].appendChild(script)
    },
    /**
     * JSONP请求
     * @param {String} url 
     * @param {Object} args 
     * @param {Function} callback 
     */
    loadJSONP: async (url = '', data = {}, options = {}) => {
        let jsonp = options.jsonp || "callback"
        let jsonpCallback = options.jsonpCallback || "jsonp_" + Math.random().toString().substr(2, 9)
        if (data && typeof data !== 'object') {
            data += `&${jsonp}=${jsonpCallback}`
        } else {
            let json = {}
            json[jsonp] = jsonpCallback
            data = { ...data, ...json }
        }
        let runMain = (fn) => {
            window[jsonpCallback] = (res) => {
                window[jsonpCallback] = null
                fn(res)
            }
            util.loadScript(url, data)
        }
        if (options.callback) {
            runMain(options.callback)
        } else {
            return new Promise((resolve, reject) => {
                runMain((res) => {
                    resolve(res)
                })
            })
        }
    },
    /**
     * 接口签名
     * @param {Object} params 
     */
    sign: (params) => {
        return new Promise((resolve, reject) => {
            infSign(params, null, {
                useH5: false,
                postType: "json",
                log: false,
                callback: (data) => {
                    resolve(data)
                }
            })
        })
    },
    /**
     * 接口风控
     * @param {String} eventid 
     * @param {String} mid 
     * @param {String} callback 
     */
    antiBrush: async (eventid, mid, callback) => {
        let KgUser = await util.getKgUser()
        KgUser.antiBrushH5({
            eventid: eventid,
            userid: 0,
            appid: "1058",
            mid: mid,
            url: window.location.href,
            callback: (res) => {
                callback && callback(res.status == 1)
            }
        })
    },
    /**
     * 获取KgUser对象
     */
    getKgUser: () => {
        if (window.KgUser) {
            return window.KgUser
        } else {
            return new Promise((resolve, reject) => {
                util.loadScript("https://staticssl.kugou.com/common/js/min/login/kguser.v2.min.js", {}, () => {
                    if (window.KgUser) {
                        resolve(window.KgUser)
                    } else {
                        resolve(null)
                    }
                })
            })
        }
    },
    /**
     * 错误输出
     * @param {String} msg 
     */
    errorOutput: (msg) => {
        switch (msg) {
            case "NETWROK_ERROR":
                msg = "网络异常，请稍候"
                break
            case "SERVICE_LIMIT":
                msg = "服务限制"
                break
            case "ANTI_ERROR":
                msg = "风控获取失败"
                break
        }
        console.warn(msg)
        return false
    },
    /**
     * 获取平台
     * @param {String} businessId 
     */
    getPlat: (businessId, specific = special.platform) => {
        var ua = navigator.userAgent.toLocaleLowerCase()
        if (ua.match(/micromessenger/gi)) {
            if (window.location.href.match(/from=timeline/)) {
                return "微信朋友圈"
            } else {
                return "微信聊天页"
            }
        } else if (specific && specific(businessId)) {
            return specific(businessId)
        } else {
            return "其他"
        }
    },
    getCookie: (cname) => {
        var name = cname + "=";
        var decodedCookie = unescape(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },
    /**
     * 埋点统计
     */
    colle: (data, options = {}) => {
        let info = player.getSongInfo()
        let ua = navigator.userAgent.toLocaleLowerCase()
        if (data.svar1) {
            data.a = "21756"
            data.b = "统计"
            data.ft = "分享插件行为数据"
            data.r = "分享插件"
            data.mid = getBaseInfo.getKgMid()
            data.svar4 = "h5"
            data.svar5 = data.svar5 ? data.svar5 : Object.keys(info).length > 0 && `${info.fileName}-${info.album_audio_id}-${info.hash}`
            data.svar6 = util.getPlat(data.svar1)
            var Clickdata = [30050, data, null, 0, { type: "GET" }];
            apmCollectData.push(Clickdata);
            try {
                newLogCount();
            } catch (error) {
            }
        }
    },
    /**
     * 加载微信JSSDK
     */
    wxLoad: (callback, time) => {
        if ((/MicroMessenger/i).test(navigator.userAgent)) {
            let fn = () => {
                window.wx.ready(() => {
                    callback && callback()
                })
            }
            setTimeout(() => {
                if (typeof window.wx == 'undefined') {
                    util.loadScript("https://staticssl.kugou.com/common/js/kg-jweixin-1.4.0.js", {}, () => {
                        window.wx.config({
                            debug: false,
                            appId: '',
                            timestamp: 1,
                            nonceStr: '',
                            signature: '',
                            jsApiList: []
                        })
                        fn()
                    })
                } else {
                    fn()
                }
            }, 1000)
        } else {
            setTimeout(callback, time || 1000)
        }
    },
    /**
     * 获取UA
     */
    getUA: function () {
        let uaMatch = function (reg) {
            return navigator.userAgent.toLocaleLowerCase().match(reg);
        }
        var ua = {}
        ua.android = uaMatch(/android/gi)
        ua.ios = uaMatch(/iphone|ipad|ios/gi)
        ua.wechat = uaMatch(/micromessenger/i) && !uaMatch(/mqqbrowser/gi)
        ua.qq = uaMatch(/qq/gi)
        ua.weibo = uaMatch(/weibo/gi)
        ua.pc = !ua.android && !ua.ios
        ua.isIE = function (ver) {
            var b = document.createElement('b')
            b.innerHTML = '<!--[if IE ' + ver + ']><i></i><![endif]-->'
            return b.getElementsByTagName('i').length === 1
        }
        return ua
    },
    /**
     * 事件监听
     * @param {*} target 
     * @param {*} method 
     * @param {*} callback 
     */
    addEventListener: (target, method, callback) => {
        target.addEventListener(method, callback, false)
        protectData.eventList.push({ target, method, callback })
    },
    /**
     * 监听事件移除
     * @param {*} target 
     * @param {*} method 
     * @param {*} callback 
     */
    removeEventListener: (target, method, callback) => {
        if (!target) {
            for (var i = 0; i < protectData.eventList.length; i++) {
                util.removeEventListener(protectData.eventList[i].target, protectData.eventList[i].method, protectData.eventList[i].callback)
            }
        } else {
            target.removeEventListener(method, callback, false)
        }
    }
}
/**
 * 对外工具
 */
const tool = {
    /**
     * 获取MID
     */
    getMid: () => {
        return getBaseInfo.getKgMid()
    },
    colle: util.colle
}
/**
 * 监听模块
 */
const listener = {
    /**
     * 取消监听
     */
    unsetListen: (method) => {
        if (method) {
            listener[method] = null
            delete listener[method]
        } else {
            for (var i in listener) {
                if (i != "setListen" && i != "listen" && i != "unsetListen") {
                    listener.unsetListen(i)
                }
            }
        }
    },
    /**
     * 设置监听
     * @param {*} method 
     * @param {*} params 
     */
    setListen: (method, params) => {
        listener[method] && listener[method](params)
    },
    /**
     * 监听回调
     * @param {*} method 
     * @param {*} func 
     */
    listen: (method, func) => {
        let tmp = listener[method]
        listener[method] = (params) => {
            tmp && tmp(params)
            func && func(params)
        }
    }
}
/**
 * 检验模块
 */
const necess = {
    /**
     * 检测是否初始播放器
     */
    necessPlayer: () => {
        if (!(/^(http|https):\/\/www.360doc\.(com|cn)/).test(window.location.href)) {
            return false
        }
        if (protectData.hasInitPlayer == false) {
            util.errorOutput("请初始化播放initPlayer")
            return false
        }
        return true
    },
    /**
     * 检测是否初始搜索
     */
    necessSearch: () => {
        if (!(/^(http|https):\/\/www.360doc\.(com|cn)/).test(window.location.href)) {
            return false
        }
        if (protectData.hasInitSearch == false) {
            util.errorOutput("请初始化搜索initSearch")
            return false
        }
        return true
    }
}
/**
 * 请求模块
 */
const inface = {
    /**
     * gw接口获取歌曲信息
     * @param {*} data 
     */
    getSongInfo: async (data, options = {}, gray) => {
        let timestamp = parseInt(new Date().getTime() / 1000).toString()
        let secretkey = "6f8qZYvfZfcIQb7s3sZqORHIDl17IL5Y"
        let postData = {
            openappid: 10204,
            timestamp: timestamp,
            nonce: md5(timestamp),
            method: "shareplugin.getsonginfo",
            v: "1",
            user_openid: "-",
            access_token: "-",
            business_data: JSON.stringify({
                hash: data.hash,
                album_audio_id: data.audio_id ? "" : data.album_audio_id || "",
                audio_id: data.audio_id || "",
                mid: timestamp,
                fullSong: 1
            })
        }
        if (gray) {
            postData.method = "shareplugin.minikugouapi"
            var business_data = JSON.parse(postData.business_data)
            business_data.method = "getsonginfo"
            postData.business_data = JSON.stringify(business_data)
        }
        let signArr = [secretkey]
        for (var i in postData) {
            signArr.push(postData[i])
        }
        signArr.sort()
        let keyStr = sha1(signArr.join(""))
        postData["signature"] = keyStr
        let result = await util.requestByRetry([
            "https://apiopen.kugou.com"
        ],
            `/gw`,
            postData,
            {
                ...(options || {}),
                postType: "urlencoded",
                type: "POST",
                headers: {
                    "Content-type": "application/x-www-form-urlencoded;charset=utf-8"
                }
            })
        protectData.rqurl = []
        protectData.rqurl.push(JSON.stringify(postData))
        return result
    },
    /**
     * 获取歌曲地址
     * @param {*} data 
     */
    getSongUrl: async (data, options = {}) => {
        let KgUser = await util.getKgUser()
        let params = await util.sign({
            cmd: 23,
            hash: data.hash,
            key: md5(data.hash + "7347ba62e49f6924ac6fd9d6bfdfd533"),
            pidversion: 3001,
            pid: 400,
            behavior: "play",
            module: "",
            appid: 3104,
            album_audio_id: data.album_audio_id || "",
            cdnBackup: "1",
            minikugou_time: new Date().getTime()
        })
        var dataStr = '' //数据拼接字符串
        Object.keys(params).forEach(function (key) {
            dataStr += key + '=' + params[key] + '&'
        })
        if (dataStr !== '') {
            dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'))
            !protectData.rqurl && (protectData.rqurl = [])
            protectData.rqurl.push(dataStr)
        }
        let result = await util.getData([
            "http://trackercdngz.kugou.com",
        ], "/v3/url", params, options)
        return result
    },
    /**
     * 获取歌曲信息
     * @param {*} hash 
     * @param {*} album_audio_id 
     */
    getAudioInfo: async (hash, album_audio_id, options = {}) => {
        if (!hash || !album_audio_id) {
            return
        }
        let appid = 3104, appkey = 'IcNtQTIEgmNOAdOlWnEaQ1LfQO1HJJTU', clientver = 1022, clienttime = +new Date();
        let result = await util.getData([
            "http://kmr.service.kugou.com",
            "https://kmrserviceretry.kugou.com"
        ], "/v3/album_audio/audio", {
            data: [
                {
                    hash: hash.toString().toUpperCase(),
                    album_audio_id: album_audio_id
                }
            ],
            show_privilege: '1',
            appid,
            clientver,
            clienttime,
            mid: 'no_bug',
            area_code: 1,
            key: md5(`${appid}${appkey}${clientver}${clienttime}`)
        }, {
            ...options,
            type: "POST"
        })
        if (result && result.data.status == 1) {
            return result.data.data
        }
        return null;
    },
}
/**
 * 播放模块
 */
const player = {
    /**
     * 播放对象数据
     */
    data: {},
    resetData: () => {
        player.data = {
            //业务ID
            businessId: null,
            //加载超时时长
            loadTime: 10000,
            //播放超时时长
            playTime: 5000,
            //播放列表
            playList: [],
            //随机播放队列
            randlist: [],
            //当前播放索引
            curIndex: -1,
            //播放
            playMode: 'cycle'
        }
    },
    /**
     * 初始化播放对象配置
     * @param {*} options 
     */
    initPlayer: (options = {}) => {
        player.resetData();
        protectData.beDestroy = 0
        protectData.hasInitPlayer = true
        protectData.launchApp = options.launchApp || false
        var data = { ...player.data, ...(options) }
        player.data = data
        if (options.businessId == "daa3e4c8decc47e99b01") {
            protectData.firstShowBar = true
        }
        //监听
        listener.listen("playSongTimeout", (data) => {
            util.errorOutput("PLAYSONG_TIMEOUT", data)
            // player.playNext()
        })
        listener.listen("playSongFail", (data) => {
            util.errorOutput("PLAYSONG_FAIL", data)
            player.data.playList[player.data.curIndex].fail = true
            // player.playNext()
        })
        listener.listen("playSongEnded", (data) => {
            player.playNext({
                manual: false
            })
        })
        listener.listen("loadSongFail", (data) => {
            if (data && data.error) {
                util.errorOutput(data.error, data.data)
            }
            player.data.playList[player.data.curIndex].fail = true
            // player.playNext()
        })
        listener.listen("loadSongTimeout", (data) => {
            util.errorOutput("NETWROK_TIMEOUT", data)
            // player.playNext()
        })
        if (!options.source) {
            util.colle({
                svar1: player.data.businessId,
                svar2: 101,
                svar3: `组件的初始化调用`
            })
            if (options.hideBar) {
                protectData.hideBar = true
            } else {
                ui.init()
            }
            //调用方为父页
            util.addEventListener(window, "message", (e) => {
                try {
                    if (typeof e.data == "string") {
                        var json = JSON.parse(e.data)
                        if (json.name == "kgPlayerRequestCallParent") {
                            json.data.jname && window[json.data.jname] &&
                                window[json.data.jname](json.data)
                        }
                    }
                } catch (ex) { }
            })
        } else {
            protectData.hideBar = true
            //search.html request.html为子页
            util.addEventListener(window, "message", (e) => {
                if (e.source != window.parent) return
                try {
                    if (typeof e.data == "string") {
                        var json = JSON.parse(e.data)
                        //父页关闭搜索时通知子页
                        if (json.name == "closeSearchCallChild") {
                            player.audioPause()
                        }
                        if (json.name == "kgPlayerRequest") {
                            util.interRequest(json.data)
                        }
                    }
                } catch (ex) { }
            })
        }
    },
    /**
     * 检测参数
     * @param {*} type 
     * @param {*} options 
     */
    checkParams: (type, options = {}) => {
        if (!player.data.businessId) {
            return "缺少businessId参数"
        }
        switch (type) {
            case "CHECK_SONG":
                if (!options.hash) {
                    return "缺少hash参数"
                }
                if (!options.album_audio_id) {
                    return "缺少album_audio_id参数"
                }
                break
            case "CHECK_PLAYLIST":
                if (player.data.playList.length == 0) {
                    return "播放列表为空"
                }
                if (!player.data.playList[options.index]) {
                    return "不存在歌曲"
                }
                break
        }
        return true
    },
    playAudioSong: (data, options) => {
        protectData.isPlayAudioSong = true
        if (data && data.album_audio_id) {
            data.audio_id = data.album_audio_id
        }
        player.playSong(data, options)
    },
    /**
     * 加载歌曲播放
     * @param {*} data 
     * @param {*} options 
     */
    playSong: (data, options = {}) => {
        if (necess.necessPlayer() == false) {
            return false
        }
        playerManager.hide = false
        if (!protectData.hideBar) {
            ui.init()
        }
        let check
        //索引播放
        if (typeof data == "number") {
            check = player.checkParams("CHECK_PLAYLIST", { index: data })
            if (check !== true) {
                listener.setListen("error", check)
                return util.errorOutput(check)
            }
            player.data.curIndex = data
        } else {
            //歌曲播放
            if (options.type == "add") {
                check = player.addSongList(data, { pos: 0 })
            } else {
                check = player.addSongList(data)
            }
            if (check === false) {
                return false
            }
            if (check !== false) {
                if (options.type == "add") {
                    player.data.curIndex = 0
                } else {
                    player.data.playList = []
                    player.addSongList(data)
                    player.data.curIndex = 0
                }
            }
        }
        protectData.timerList.initTimer && clearTimeout(protectData.timerList.initTimer)
        protectData.playerMark = null
        protectData.timerList.initTimer = setTimeout(async () => {
            let song = await player.loadSong(player.data.playList[player.data.curIndex])
            if (song && song.initSong) {
                player.data.playList[player.data.curIndex] = song
            }
        }, 100)

    },
    /**
     * 增加播放歌曲列表
     * @param {*} list 
     * @param {*} options 
     */
    addSongList: (list, options = {}) => {
        if (necess.necessPlayer() == false) {
            return false
        }
        // if (player.data.audio) {
        //     return false
        // }
        if (!list) {
            return false
        }
        if (list instanceof Object && !(list instanceof Array)) {
            list = [list]
        }
        var check = list.map(v => player.checkParams("CHECK_SONG", v)).filter(v => v !== true)
        if (check.length > 0) {
            listener.setListen("error", check[0])
            return util.errorOutput(check[0])
        }
        let info = player.data.playList[player.data.curIndex]
        if (typeof options.pos == "number") {
            var tmp1 = player.data.playList.slice(0, options.pos),
                tmp2 = player.data.playList.slice(options.pos, player.data.playList.length)
            player.data.playList = [...tmp1, ...list, ...tmp2]
        }
        else {
            player.data.playList = [...player.data.playList, ...list]
        }
        info && (player.updateIndex(info))
        return player.data.playList
    },
    /**
     * 更新索引
     * @param {*} info 
     */
    updateIndex: (info = {}) => {
        if (necess.necessPlayer() == false) {
            return false
        }
        let index = player.data.playList.findIndex((v) => v.hash == info.hash)
        if (index > -1) {
            player.data.curIndex = index
            //随机播放下重新排序
            if (player.data.playMode == "random") {
                player.changePlayMode("random")
            }
        }
    },
    /**
     * 加载歌曲
     */
    loadSong: async (data) => {
        try {
            if (necess.necessPlayer() == false) {
                return false
            }
            //在空情况下播放一次，ios才能自动播放
            if (!playerManager.src) {
                playerManager.play()
            }
            let timeout = false
            let result;
            let startTime = new Date().getTime()
            protectData.timerList.loadTimer && (clearTimeout(protectData.timerList.loadTimer))
            protectData.timerList.loadTimer = setTimeout(() => {
                timeout = true
                listener.setListen("loadSongTimeout", data)
                util.colle({
                    svar1: player.data.businessId,
                    svar2: 128,
                    svar3: '加载歌曲超时'
                }, {
                    result: result || "",
                    time: new Date().getTime() - startTime,
                    rqurl: protectData.rqurl
                })
            }, player.data.loadTime * 2 + 100)
            // 部分第三方APP禁止了POST，所以只能用旧接口
            var noUsePost = location.href.match(/www.meipian.cn\/1003/) || location.href.match(/www.360doc.cn\/musicEditor\/musicplayer.html/)
            if (!noUsePost) {
                result = await inface.getSongInfo(data, {
                    timeout: player.data.loadTime,
                    pmTimeout: true,
                    timeoutCallback: function (data, option) {
                        util.colle({
                            svar1: player.data.businessId,
                            svar2: 140,
                            svar3: '加载gw接口耗时'
                        }, {
                            time: option.time,
                            rqurl: option.url
                        })
                    }
                }, player.data.businessId == "daa3e4c8decc47e99b01")
                //被销毁后的延迟回调都不执行
                if (protectData.beDestroy) {
                    return
                }
                protectData.getDataType = 1
            }
            //超时重试到gw
            if (!result) {
                result = await inface.getSongUrl(data, {
                    timeout: player.data.loadTime,
                    pmTimeout: true,
                    noRetry: noUsePost ? false : true,
                    timeoutCallback: function (data, option) {
                        util.colle({
                            svar1: player.data.businessId,
                            svar2: 139,
                            svar3: '加载接口耗时'
                        }, {
                            time: option.time,
                            rqurl: option.url
                        })
                    }
                })
                //被销毁后的延迟回调都不执行
                if (protectData.beDestroy) {
                    return
                }
                protectData.getDataType = 2
            }
            if (!result) {
                if (result === null) {
                    listener.setListen("loadSongFail", { data, error: "NETWROK_ERROR" })
                    util.colle({
                        svar1: player.data.businessId,
                        svar2: 129,
                        svar3: '加载歌曲失败'
                    })
                }
                return false
            }
            protectData.timerList.loadTimer && (clearTimeout(protectData.timerList.loadTimer))
            //非同一首歌曲拒绝
            if (player.data.playList && player.data.playList.length > 0 && player.data.playList[player.data.curIndex]) {
                if (player.data.playList[player.data.curIndex].hash != data.hash) {
                    return false
                }
            }
            if (timeout) {
                return false
            }
            if (result.data.status != 1 || (protectData.getDataType == 1 && result.data && result.data.data && !result.data.data.url)) {
                //风控
                if (result.data.errcode == 1002) {
                    var eventid = result.header["ssa-code"]
                    var mid = result.header["ssa-hmid"]
                    await util.antiBrush(eventid, mid, (success) => {
                        !success && (listener.setListen("loadSongFail", {
                            data,
                            error: "ANTI_ERROR"
                        }))
                    })
                    return false
                } else {
                    let gwFail = protectData.getDataType == 1 && result.data && result.data.data && result.data.data.privilegeType != 1
                    let errorMsg = ({ "0": "获取资源失败", 2: "资源需付费", 3: "禁止获取资源", 4: "禁止获取资源" })
                    listener.setListen("loadSongFail", { data, error: gwFail ? errorMsg[2] : errorMsg[result.data.status] })
                    util.colle({
                        svar1: player.data.businessId,
                        svar2: 130,
                        svar3: '加载歌曲阻拦'
                    }, {
                        time: new Date().getTime() - startTime,
                        failType: gwFail ? errorMsg[2] : (errorMsg[result.data.status] || result.data.status)
                    })
                    return false
                }
            } else {
                util.colle({
                    svar1: player.data.businessId,
                    svar2: 138,
                    svar3: '加载歌曲成功'
                }, {
                    time: new Date().getTime() - startTime
                })
                let song;
                let duration;
                if (protectData.getDataType == 1) {
                    protectData.songUrlData = result.data.data
                    song = [[result.data.data]]
                    duration = result.data.data.audio_info.timelength / 1000
                } else {
                    protectData.songUrlData = result.data
                    duration = result.data.timeLength
                    song = await inface.getAudioInfo(data.hash, data.album_audio_id, {
                        timeout: 5000
                    })
                    //被销毁后的延迟回调都不执行
                    if (protectData.beDestroy) {
                        return
                    }
                }
                if (song && song[0] && song[0][0]) {
                    protectData.audioInfoData = song[0][0]
                    data["fileName"] = song[0][0].author_name + " - " + song[0][0].songname
                    data["singerName"] = song[0][0].author_name
                    data["songName"] = song[0][0].songname
                    data["duration"] = duration
                    data["classType"] = typeof song[0][0].classType == 'undefined' ? "" : song[0][0].classType
                    data["initSong"] = true
                } else {
                    data["fileName"] = result.data.fileName
                    data["singerName"] = result.data.fileName.split(" - ")[0]
                    data["songName"] = result.data.fileName.split(" - ")[1]
                    data["duration"] = duration
                    data["classType"] = ""
                    data["initSong"] = true
                }
                listener.setListen("loadSongSuccess", data)
                !(function () {
                    let songName = player.getSongInfo()['songName']
                    //切歌
                    if (protectData.barText != songName) {
                        if (!protectData.firstShowBar) {
                            protectData.firstShowBar = true
                            ui.changeBarText(songName)
                            ui.fullBar()
                        } else {
                            ui.changeBarText(songName)
                        }
                    }
                    protectData.barText = songName
                })()
                if (protectData.getDataType == 1) {
                    player.playAudio({
                        url: result.data.data.url,
                        backupUrl: "",
                        info: data
                    })
                } else {
                    player.playAudio({
                        url: result.data.url,
                        backupUrl: result.data.backupUrl,
                        info: data
                    })
                }

                return data
            }
        } catch (ex) {
            protectData.timerList.loadTimer && (clearTimeout(protectData.timerList.loadTimer))
            util.colle({
                svar1: player.data.businessId,
                svar2: 137,
                svar3: '加载歌曲报错'
            }, {
                error: ex.toString()
            })
            return false
        }
    },
    loadSongInfo: async (data) => {
        try {
            if (necess.necessPlayer() == false) {
                return false
            }
            let getDataType = 1
            let result;
            result = await inface.getSongInfo(data, {
                timeout: player.data.loadTime,
                pmTimeout: true,
                timeoutCallback: function (data, option) { }
            }, false)
            //超时重试到gw
            if (!result) {
                result = await inface.getSongUrl(data, {
                    timeout: player.data.loadTime,
                    pmTimeout: true,
                    noRetry: false,
                    timeoutCallback: function (data, option) { }
                })
                getDataType = 2
            }
            if (!result) {
                return { error: "加载歌曲失败" }
            }
            if (result.data.status != 1 || (getDataType == 1 && result.data && result.data.data && !result.data.data.url)) {
                //风控
                if (result.data.errcode == 1002) {
                    return { error: "风控" }
                } else {
                    let gwFail = protectData.getDataType == 1 && result.data && result.data.data && result.data.data.privilegeType != 1
                    let errorMsg = ({ "0": "获取资源失败", 2: "资源需付费", 3: "禁止获取资源", 4: "禁止获取资源" })
                    return { error: gwFail ? errorMsg[2] : (errorMsg[result.data.status] || result.data.status) }
                }
            } else {
                let song;
                let duration;
                if (getDataType == 1) {
                    song = [[result.data.data]]
                    duration = result.data.data.audio_info.timelength / 1000
                } else {
                    duration = result.data.timeLength
                    song = await inface.getAudioInfo(data.hash, data.album_audio_id, {
                        timeout: 5000
                    })
                }
                if (song && song[0] && song[0][0]) {
                    data["fileName"] = song[0][0].author_name + " - " + song[0][0].songname
                    data["singerName"] = song[0][0].author_name
                    data["songName"] = song[0][0].songname
                    data["duration"] = duration
                    data["classType"] = typeof song[0][0].classType == 'undefined' ? "" : song[0][0].classType
                    return { ...data, ...song[0][0] }

                } else {
                    data["fileName"] = result.data.fileName
                    data["singerName"] = result.data.fileName.split(" - ")[0]
                    data["songName"] = result.data.fileName.split(" - ")[1]
                    data["duration"] = duration
                    data["classType"] = ""
                    return data
                }
            }
        } catch (ex) {
            return { error: "加载歌曲报错" }
        }
    },
    /**
     * 播放音频
     */
    playAudio: (options) => {
        if (necess.necessPlayer() == false) {
            return false
        }
        playerManager.options = options
        //超时处理
        protectData.timerList.audioTimer && clearTimeout(protectData.timerList.audioTimer)
        protectData.timerList.audioTimer = setTimeout(() => {
            listener.setListen("playSongTimeout", playerManager.options.info)
            util.colle({
                svar1: player.data.businessId,
                svar2: 131,
                svar3: '播放歌曲超时'
            })
        }, player.data.playTime)
        protectData.canAutoPlay = true
        if (protectData.initPlayerManager == false) {
            protectData.initPlayerManager = true
            player.addEvent("pushAll")
            //播放继续
            playerManager.onplay = (e) => {
                ui.toggleStatus()
            }
            //播放暂停
            playerManager.onpause = (e) => {
                ui.toggleStatus()
            }
            //是否可以播放
            playerManager.oncanplay = (e) => {
                if (protectData.timerList.audioTimer) {
                    clearTimeout(protectData.timerList.audioTimer)
                    protectData.timerList.audioTimer = null
                    listener.setListen("playSongSuccess", playerManager.options.info)
                }
            }
            //播放更新
            playerManager.ontimeupdate = (e) => {
                if (protectData.canAutoPlay) {
                    util.colle({
                        svar1: player.data.businessId,
                        svar2: 114,
                        svar3: '播放成功'
                    })
                    protectData.canAutoPlay = false
                }
            }
            //播放错误
            playerManager.onerror = (e) => {
                if (playerManager.hide) {
                    return false
                }
                if (playerManager.options.backupUrl && playerManager.options.backupUrl.length > 0) {
                    playerManager.src = playerManager.options.backupUrl[0]
                    player.audioPlay()
                    playerManager.options.backupUrl = null
                } else {
                    protectData.timerList.audioTimer && (clearTimeout(protectData.timerList.audioTimer))
                    listener.setListen("playSongFail", playerManager.options.info)
                    util.colle({
                        svar1: player.data.businessId,
                        svar2: 131,
                        svar3: '播放歌曲失败'
                    })
                }
            }
            //播放结束
            playerManager.onended = (e) => {
                listener.setListen("playSongEnded", playerManager.options.info)
            }
        }
        playerManager.src = options.url
        if (protectData.playerMark == "pause") {
            player.audioPause()
        } else if (protectData.playerMark == "play") {
            player.audioPlay()
        } else {
            player.audioPlay()
        }
        let touchEvent = util.getUA().pc ? "click" : "touchend"
        let touch = (event) => {
            if (playerManager.hide) {
                return
            }
            if (event.target && event.target.parentNode && /kg-player/.test(event.target.parentNode.className)) {
            } else {
                if (protectData.playerMark == "pause") {
                    player.audioPause()
                } else {
                    player.audioPlay()
                }
            }
            document.removeEventListener(touchEvent, touch)
        }
        setTimeout(() => {
            ui.toggleStatus()
            document.addEventListener(touchEvent, touch)
        }, 100)
    },
    /**
     * 获取歌曲索引
     * @param {*} index 
     * @param {*} options 
     */
    getIndex: (index, options = {}) => {
        var p, n
        if (player.data.playList.length == 1) {
            p = n = index = 0
        } else {
            index == -1 && (index = 0)
            //顺序播放
            if (player.data.playMode == "loop") {
                p = index == 0 ? -1 : +index - 1
                n = index == player.data.playList.length - 1 ? -1 : +index + 1
            }
            //单曲播放
            if (player.data.playMode == "once") {
                p = n = index
            }
            //列表循环
            if (player.data.playMode == "cycle" || options.manual) {
                p = index == 0 ? player.data.playList.length - 1 : +index - 1
                n = index == player.data.playList.length - 1 ? 0 : +index + 1
            }
            //随机播放
            var r = player.data.randlist
            if ((player.data.playMode == "random" || options.manual) && r && r.length > 0) {
                for (var i in r) {
                    if (r[i] == index) {
                        p = r[i == 0 ? r.length - 1 : +i - 1]
                        n = r[i == r.length - 1 ? 0 : +i + 1]
                        break
                    }
                }
            }
        }
        return {
            prev: p,
            cur: index,
            next: n
        }
    },
    /**
     * 改变播放模式
     * @param {*} mode 
     */
    changePlayMode: (mode) => {
        if (necess.necessPlayer() == false) {
            return false
        }
        if (!/^cycle$|^loop$|^once$|^random$/.test(mode)) {
            return false
        }
        player.data.playMode = mode
        var randlist = []
        if (mode == "random") {
            randlist = player.data.playList.map((v, i) => i)
            var i = randlist.length,
                a,
                b,
                t
            if (i > 2) {
                while (i) {
                    a = i - 1
                    b = Math.floor(Math.random() * i)
                    i--
                    if (a == b) continue
                    t = randlist[a]
                    randlist[a] = randlist[b]
                    randlist[b] = t
                }
            }
        }
        player.data.randlist = randlist
    },
    /**
     * 播放哪个
     */
    whichPlay: (type, options = {}) => {
        if (necess.necessPlayer() == false) {
            return false
        }
        //全部播放失败的
        if (player.data.playList.filter(v => v.fail == true).length == player.data.playList.length) {
            return
        }
        let indexs = player.getIndex(player.data.curIndex, options)
        if (indexs[type] == -1) {
            return false
        }
        player.data.curIndex = indexs[type]
        if (player.data.playList[player.data.curIndex].fail == true) {
            player.playNext()
        } else {
            if (protectData.isPlayAudioSong) {
                player.playAudioSong(indexs[type])
            } else {
                player.playSong(indexs[type])
            }
        }
    },
    /**
     * 播放下一首
     */
    playNext: (options = {}) => {
        if (necess.necessPlayer() == false) {
            return false
        }
        player.whichPlay("next", {
            ...{ manual: true }, ...options
        })
    },
    /**
     * 播放上一首
     */
    playPrev: () => {
        if (necess.necessPlayer() == false) {
            return false
        }
        player.whichPlay("prev", {
            manual: true
        })
    },
    /**
     * 播放歌曲
     * @param {*} isUserDo 
     */
    play: (isUserDo) => {
        if (playerManager.hide) {
            return
        }
        if (necess.necessPlayer() == false) {
            return false
        }
        protectData.playerMark = "play"
        if (isUserDo == true) {
            util.colle({
                svar1: player.data.businessId,
                svar2: 115,
                svar3: '用户点击播放'
            })
        } else {
            util.colle({
                svar1: player.data.businessId,
                svar2: 105,
                svar3: '代码调用播放'
            })
        }
        player.audioPlay()
    },
    /**
     * 暂停歌曲
     * @param {*} isUserDo 
     */
    pause: (isUserDo) => {
        if (playerManager.hide) {
            return
        }
        if (necess.necessPlayer() == false) {
            return false
        }
        protectData.playerMark = "pause"
        if (isUserDo == true) {
            util.colle({
                svar1: player.data.businessId,
                svar2: 116,
                svar3: '用户点击暂停'
            })
        } else {
            util.colle({
                svar1: player.data.businessId,
                svar2: 104,
                svar3: '代码调用暂停'
            })
        }
        player.audioPause()
    },
    /**
     * audio播放判断（不同于play(),这是audio播放，没有其他业务）
     */
    audioPlay: () => {
        if (playerManager && playerManager.src) {
            let p = playerManager.play()
            if (p != undefined) {
                p.catch(error => {
                    listener.setListen("audioPlayFail", error)
                })
            }
        }
    },
    /**
     * audio暂停（不同于pause(),这是audio暂停，没有其他业务）
     */
    audioPause: () => {
        if (playerManager && playerManager.src) {
            playerManager.pause()
        }
    },
    /**
     * 暂停/播放歌曲
     */
    toggle: () => {
        if (necess.necessPlayer() == false) {
            return false
        }
        if (playerManager && playerManager.src) {
            playerManager.paused ? (player.play()) : (player.pause())
        } else {
            protectData.playerMark = (protectData.playerMark == "pause" ? "play" : "pause")
        }
    },
    /**
     * 获取播放状态
     */
    getPlayStatus: () => {
        if (playerManager && playerManager.src) {
            return playerManager.paused ? "pause" : "play"
        } else if (protectData.playerMark) {
            return protectData.playerMark
        }
    },
    /**
     * 获取歌曲信息
     */
    getSongInfo: () => {
        if (player.data.curIndex == -1) {
            return {}
        }
        return player.data.playList[player.data.curIndex] || {}
    },
    /**
     * 获取歌曲列表信息
     */
    getSongList: () => {
        return player.data.playList || []
    },
    /**
     * 增加绑定事件
     * @param {*} method 
     * @param {*} fn 
     */
    addEvent: (method, fn) => {
        if (!protectData.initPlayerManager) {
            !player.eventList && (player.eventList = [])
            player.eventList.push({
                method, fn
            })
        } else {
            if (method == "pushAll" && player.eventList) {
                player.eventList.forEach(v => {
                    player.addEvent(v.method, v.fn)
                })
                player.eventList = null
            } else {
                util.addEventListener(playerManager, method, (e) => {
                    fn && fn(playerManager.options.info, e)
                })
            }
        }
    },
    getPlayerManager: () => {
        return playerManager
    },
    /**
     * 跳转播放页
     */
    jump: (hash, album_audio_id, auto) => {
        var cmlid, songname, singername;
        if (hash instanceof Object) {
            var json = hash
            hash = json.hash
            album_audio_id = json.album_audio_id
            auto = json.auto
            cmlid = json.cmlid
            songname = json.songname
            singername = json.singername
        }
        if (necess.necessPlayer() == false) {
            return false
        }
        util.colle({
            svar1: player.data.businessId,
            svar2: 103,
            svar3: `“更多”菜单的点击`
        })
        var info = player.getSongInfo()
        !hash && (hash = info.hash)
        !album_audio_id && (album_audio_id = info.album_audio_id)
        setTimeout(() => {
            var ua = util.getUA()
            if (ua.pc) {
                special.launchPC()
                return
            }
            var launch = false
            //设置了自动拉起
            if (auto) {
                launch = ua.ios ? true : false
            }
            //第三方客户端 浏览器
            if (!ua.wechat && !ua.qq && !ua.weibo) {
                launch = true
            }
            if (ua.ios && ua.qq) {
                launch = false
            }
            special.launchListen(player.data.businessId, launch, function () {
                var other = []
                if (hash) {
                    other.push("hash=" + hash)
                }
                if (album_audio_id) {
                    other.push("album_audio_id=" + album_audio_id)
                }
                if (cmlid) {
                    other.push("cmlid=" + cmlid)
                }
                //盆友圈链接要带过去
                if (window.location.href.match(/from=timeline/)) {
                    other.push("from=timeline")
                }
                if (info.fileName) {
                    other.push("name=" + encodeURIComponent(info.fileName))
                } else if (songname) {
                    other.push("name=" + encodeURIComponent((singername ? singername + " - " : "") + songname))
                }
                if (auto) {
                    other.push("jump=1")
                }
                if (player.data.inPartnerApp) {
                    other.push("inPartnerApp=1")
                }
                var page = "indexV2.html"
                if (player.data.businessId == "daa3e4c8decc47e99b01") {
                    page = "index.html"
                }
                // window.location.href = domain + "/" + page + "?businessId=" + player.data.businessId + (other.length > 0 ? "&" : "") + other.join("&")
                window.open(domain + "/" + page + "?businessId=" + player.data.businessId + (other.length > 0 ? "&" : "") + other.join("&"))
            })
        }, 100)
    },
    /**
     * 隐藏
     */
    destroy: (falg) => {
        //强制销毁
        if (falg) {
            //移除监听
            listener.unsetListen()
            util.removeEventListener()
            //清除定时器
            for (var i in protectData.timerList) {
                if (protectData.timerList[i]) {
                    clearTimeout(protectData.timerList[i])
                    protectData.timerList[i] = null
                }
            }
            //初始化对象
            playerManager.src = ""
            playerManager.onplay = playerManager.onpause = playerManager.oncanplay = playerManager.ontimeupdate = playerManager.onerror = playerManager.onended = null
            playerManager = null
            playerManager = new Audio()
            playerManager.src = ""
            resetProtectData()
            player.resetData()
            //清除UI
            if (document.getElementById("kgCD")) {
                document.getElementById("kgCD").parentNode.removeChild(document.getElementById("kgCD"))
            }
            protectData.beDestroy = 1
            return
        }
        //保留不动，只隐藏
        if (document.getElementById("kgCD")) {
            document.getElementById("kgCD").parentNode.removeChild(document.getElementById("kgCD"))
        }
        protectData.firstShowBar = null
        playerManager.hide = true
        playerManager.src = ""
        protectData.timerList.checkTimer && (clearTimeout(protectData.timerList.checkTimer))
    }
}
/**
 * UI模块
 */
const ui = {
    /**
     * UI初始化
     */
    init: () => {
        if (document.getElementById("kgCD")) {
            return
        }
        let kg = document.createElement("div")
        let scale = Math.min((document.querySelector("html").offsetWidth / 750), 0.5)
        var vp = document.querySelector('[name=viewport]')
        var vp_scale = 1;
        if (vp) {
            var arr = vp.getAttribute("content").split(",")
            for (var i = 0; i < arr.length; i++) {
                var arr2 = arr[i].split("=")
                if (arr2[0].match(/initial-scale|maximum-scale|minimum-scale/)) {
                    vp_scale = arr2[1]
                    break
                }
            }
        }

        kg.id = "kgCD"
        kg.innerHTML = pendant;
        protectData.scale = scale / vp_scale;
        kg.style.cssText = [
            "transform: scale(" + scale / vp_scale + ")",
        ]
        document.body.appendChild(kg)
        ui.setKeyframes(null, "move-text")
        let touchEvent = util.getUA().pc ? "onclick" : "ontouchend"

        kg.querySelector(".kg-player-cover")[touchEvent] = (e) => {
            if (!player.getSongInfo()["initSong"]) {
                return
            }
            if (player.getPlayStatus() == "pause") {
                player.play(true)
            } else {
                player.pause(true)
            }
            ui.fullBar()
            e.stopPropagation()
        }
        kg.querySelector(".kg-player-jump")[touchEvent] = (e) => {
            player.jump(undefined, undefined, protectData.launchApp)
            e.stopPropagation()
        }
        kg[touchEvent] = (e) => {
            e.stopPropagation()
        }
        ui.scrollMiniBar()
        ui.dargBar()
        if (!protectData.hideBar) {
            protectData.timerList.checkTimer = setTimeout(() => {
                if (ui.checkBar()) {
                    util.colle({
                        svar1: player.data.businessId,
                        svar2: 141,
                        svar3: "挂件被隐藏"
                    })
                }
                if (ui.checkLogo()) {
                    util.colle({
                        svar1: player.data.businessId,
                        svar2: 142,
                        svar3: "挂件logo被替换"
                    })
                }
                if (ui.checkScale()) {
                    util.colle({
                        svar1: player.data.businessId,
                        svar2: 145,
                        svar3: "挂件被缩放"
                    })
                }
            }, 5000);
        }
    },
    /**
     * 动态设置keyframes
     */
    setKeyframes: (ele, key, frames, styleText) => {
        if (!ele) {
            const runkeyframes = ` @keyframes ${key}{
                0% {
                    transform: translateX(0)
                }
                100% {
                    transform: translateX(-100%)
                }
            }`
            const style = document.createElement('style')
            style.type = 'text/css'
            style.innerHTML = runkeyframes
            document.getElementsByTagName('head')[0].appendChild(style)
            return
        }
        let getkeyframes = (name) => {
            var animation = {};
            // 获取所有的style
            var ss = document.styleSheets
            for (var i = 0; i < ss.length; ++i) {
                const item = ss[i]
                if (item.cssRules[0] && item.cssRules[0].name && item.cssRules[0].name === name) {
                    animation.cssRule = item.cssRules[0]
                    animation.styleSheet = ss[i]
                    animation.index = 0
                    break
                }
            }
            return animation;
        }
        try {
            const keyframes = getkeyframes(key)
            keyframes.styleSheet.deleteRule(keyframes.index)
            keyframes.styleSheet.insertRule(`@keyframes ${key}${frames}`, keyframes.index)
            ele.style.animation = styleText
        } catch (ex) { }
    },
    /**
     * 检测是否符合条件
     */
    check: () => {
        if (protectData.hideBar) {
            return false
        }
        if (!player.getSongInfo()["initSong"]) {
            return false
        }
        return true
    },
    /**
     * 显示完整挂件
     */
    fullBar: () => {
        if (ui.check() == false) {
            return false
        }
        let ele = document.querySelector("#kgCD .kg-player-pendant")
        if (ele && /kg-player-mini/.test(ele.className)) {
            ele.className = ele.className.replace("kg-player-mini", "")
            protectData.timerList.barTimer && (clearTimeout(protectData.timerList.barTimer))
            protectData.timerList.barTimer = setTimeout(() => {
                ele.className = ele.className.replace("kg-player-hide", "")
                ui.moveText()
            }, 1100)
            //10秒后收起
            protectData.timerList.miniTimer && clearTimeout(protectData.timerList.miniTimer)
            protectData.timerList.miniTimer = setTimeout(() => {
                ui.miniBar()
            }, 1000 * 10)
        }
    },
    /**
     * 显示mini挂件
     */
    miniBar: () => {
        if (ui.check() == false) {
            return false
        }
        if (player.data.keepBarShow) {
            return false
        }
        let ele = document.querySelector("#kgCD .kg-player-pendant")
        if (ele && !(/kg-player-mini/.test(ele.className))) {
            ele.className = ele.className += ' kg-player-mini kg-player-hide'
            protectData.timerList.miniTimer && clearTimeout(protectData.timerList.miniTimer)
        }
    },
    /**
     * 修改bar文字
     */
    changeBarText: (name) => {
        if (ui.check() == false) {
            return false
        }
        let ele = document.querySelector("#kgCD .kg-player-pendant")
        ele.querySelector(".kg-player-song-wrap").style.cssText = ""
        ele.querySelector(".kg-player-song-wrap").innerHTML = [
            `<span>${name + " - 来自酷狗音乐"}</span>`,
            `<span>${name + " - 来自酷狗音乐"}</span>`
        ].join("")
        ui.moveText()
    },
    /**
     * 文字滚动
     */
    moveText: () => {
        if (ui.check() == false) {
            return false
        }
        let ele = document.querySelector("#kgCD .kg-player-pendant")
        protectData.timerList.textTimer && (clearTimeout(protectData.timerList.textTimer))
        protectData.timerList.textTimer = setTimeout(() => {
            let text = ele.querySelectorAll(".kg-player-song-wrap span")
            ui.setKeyframes(ele.querySelector(".kg-player-song-wrap"), "move-text", `{
                0% { transform: translate3d(0,0,0)}
                100% { transform: translate3d(${text[0].offsetLeft - text[1].offsetLeft}px,0,0)}
            }`, "move-text 5s linear infinite")
        }, 1000)
    },
    /**
     * UI切换暂停/播放
     */
    toggleStatus: () => {
        if (ui.check() == false) {
            return false
        }
        let cover = document.querySelector("#kgCD .kg-player-cover")
        if (player.getPlayStatus() == "pause") {
            var child = cover.getElementsByTagName("i")[0]
            var parent = child.parentNode
            var iTransform = getComputedStyle(child).transform
            var cTransform = getComputedStyle(parent).transform
            parent.style.transform = cTransform === 'none'
                ? iTransform
                : iTransform.concat(' ', cTransform)
            cover.className = cover.className.replace(/\bpause\b|\bplay\b/g, "") + " pause"
        } else {
            cover.className = cover.className.replace(/\bpause\b|\bplay\b/g, "") + " play"
        }
    },
    /**
     * 滚动显示minibar
     */
    scrollMiniBar: (ele, long = 50) => {
        let start = 0
        util.addEventListener(document, "touchstart", () => {
            start = ele ? ele.scrollTop : document.body.scrollTop || document.documentElement.scrollTop
        })
        util.addEventListener(document, util.getUA().pc ? "click" : "touchend", () => {
            ui.miniBar()
        })
        if (ele) {
            util.addEventListener(ele, "scroll", () => {
                if (ele.scrollTop - start > long) {
                    ui.miniBar()
                }
            })
        } else {
            util.addEventListener(window, "scroll", () => {
                let t = document.body.scrollTop || document.documentElement.scrollTop
                if (t - start > long) {
                    ui.miniBar()
                }
            })
        }
    },
    /**
     * 挂件拖动
     */
    dargBar: () => {
        if (necess.necessPlayer() == false) {
            return false
        }
        if (protectData.hideBar) {
            return false
        }
        let kg = document.querySelector("#kgCD")
        let disY = 0
        let darg = false
        let scale = Math.min((document.querySelector("html").offsetWidth / 750), 0.5)
        kg.ontouchstart = () => {
            disY = event.changedTouches[0].clientY - kg.offsetTop
        }
        kg.ontouchmove = () => {
            let y = event.changedTouches[0].clientY - disY
            let maxT = document.documentElement.clientHeight - kg.offsetHeight * scale
            y = y < 0 ? 0 : (y > maxT ? maxT : y)
            kg.style.top = y + "px"
        }
    },
    /**
     * 设置皮肤
     */
    setSkin: (colors = {}) => {
        if (necess.necessPlayer() == false) {
            return false
        }
        if (protectData.hideBar) {
            return false
        }
        if (colors.panel) {
            document.querySelector("#kgCD .kg-player-pendant").style.backgroundColor = colors.panel
        }
        if (colors.song) {
            document.querySelector("#kgCD .kg-player-song").style.color = colors.song
        }
        if (colors.jump) {
            document.querySelector("#kgCD .kg-player-jump").style.color = colors.jump
            document.querySelector("#kgCD .kg-player-arrow").style.color = colors.jump
        }

    },
    /**
     * 检测logo是否存在
     */
    checkLogo: () => {
        var $ele = document.querySelector(".kg-player-move")
        if (!$ele) {
            return false
        }
        //节点是否被修改
        if ($ele.innerHTML != "<i></i>") {
            return true
        }
        var styles = window.getComputedStyle($ele.querySelector("i"))
        if (styles && styles.backgroundImage) {
            //图片地址是否被修改
            if (!/webimg\.kgimg\.com\/6e6fb7b67807dcfc8e5fe4f35a692e21\.png/.test(styles.backgroundImage)) {
                return true
            }
        }
    },
    /**
     * 检测挂件是否被隐藏
     */
    checkBar: () => {
        var $ele = document.querySelector("#kgCD")
        //节点被干掉
        if (!$ele) {
            return true
        }
        var styles = window.getComputedStyle($ele)
        //节点被隐藏
        if (styles.display == "none" || styles.visibility == "hidden" || styles.opacity == 0) {
            return true
        }
    },
    /**
     * 检测挂件是否被放大、缩小
     */
    checkScale: () => {
        var $ele = document.querySelector("#kgCD")
        if (!$ele) {
            return false
        }
        if (!$ele.style.transform) {
            return false
        }
        var reg = $ele.style.transform.match(/scale\((.*?)\)/)
        if (reg && reg[1]) {
            if (protectData.scale != reg[1]) {
                return true
            }
        }
    }
}
/**
 * 搜索模块
 */
const search = {
    data: {
        //业务ID
        businessId: null
    },
    /**
     * 初始化搜索对象配置
     * @param {*} options 
     */
    initSearch: (options = {}) => {
        protectData.hasInitSearch = true
        var data = { ...search.data, ...(options) }
        search.data = data
        //调用方为父页
        window.addEventListener('message', (e) => {
            try {
                if (typeof e.data == "string") {
                    var json = JSON.parse(e.data)
                    //子页播放歌曲通知父页
                    if (json.name == "playSongCallParent") {
                        listener.setListen("childPlaySongCallback")
                        player.audioPause()
                    }
                    //子页选择歌曲通知父页
                    if (json.name == "choiceSongCallParent") {
                        listener.setListen("childChoiceSongCallback", json.data)
                        search.hide()
                    }
                    //子页通知父页关闭
                    if (json.name == "closeSearchCallParent") {
                        listener.setListen("closeSearchCallback")
                        search.hide()
                    }
                }
            } catch (ex) { }
        }, false)
    },
    /**
     * 子页播放歌曲通知父页
     */
    playSongCallParent: () => {
        if (window.parent == window.self) {
            search.set("childPlaySongCallback")
            return
        }
        window.parent.postMessage(JSON.stringify({
            name: "playSongCallParent"
        }), '*')
    },
    /**
     * 子页选择歌曲通知父页
     * @param {Object} options 
     */
    choiceSongCallParent: (options) => {
        let data = {
            hash: options.hash,
            id: options.id,
            name: options.name,
            album_audio_id: options.album_audio_id,
            businessId: options.businessId
        }
        if (window.parent == window.self) {
            search.set("childChoiceSongCallback", data)
            listener.setListen("childChoiceSongCallback", data)
            return
        }
        window.parent.postMessage(JSON.stringify({
            name: "choiceSongCallParent",
            data: data
        }), '*')
    },
    /**
     * 子页通知父页关闭
     */
    closeSearchCallParent: () => {
        if (window.parent == window.self) {
            listener.setListen("closeSearchCallback")
            return
        }
        player.audioPause()
        window.parent.postMessage(JSON.stringify({
            name: "closeSearchCallParent"
        }), '*')
    },
    /**
     * 父页关闭搜索时通知子页
     */
    closeSearchCallChild: (id) => {
        var ele = document.getElementById(id).contentWindow || window.frames[0]
        ele.postMessage(JSON.stringify({
            "name": "closeSearchCallChild"
        }), document.getElementsByTagName("iframe")[0].src)
    },
    /**
     * 调用API模式显示
     */
    show: (options = {}) => {
        if (necess.necessSearch() == false) {
            return false
        }
        if (!search.data.businessId) {
            return util.errorOutput("缺少businessId参数")
        }
        let url = domain + "/search.html?" + [
            "businessId=" + search.data.businessId,
            ...(options.close || options.type != 'inner' ? ["showtitle=1"] : []),
            ...(window.location.href.match(/from=timeline/) ? ["from=timeline"] : [])
        ].join("&")
        if (options.type == "jump") {
            window.location.href = url
            return false
        }
        let iframe = document.getElementById("kgPlayerIframe")
        if (!iframe) {
            iframe = document.createElement("iframe")
            iframe.id = "kgPlayerIframe"
            iframe.src = url
            let cssText = ""
            switch (options.type) {
                case "inner":
                    cssText = [
                        "width:100%",
                        "height:100%",
                        "border:0 none"
                    ]
                    break
                default:
                    cssText = [
                        "width:100%",
                        "height:100%",
                        "border:0 none",
                        "position:absolute",
                        "top:0",
                        "bottom:0",
                        "left:0",
                        "right:0",
                        "z-index:99999"
                    ]
                    break
            }
            iframe.style.cssText = cssText.join(";")
            if (options.id) {
                document.getElementById(options.id).appendChild(iframe)
            } else {
                document.body.appendChild(iframe)
            }
        }
        iframe.style.display = "block"
    },
    /**
     * 调用API模式关闭
     */
    hide: () => {
        var iframe = document.getElementById("kgPlayerIframe")
        if (iframe) {
            iframe.parentNode.removeChild(iframe)
        }
    },
    /**
     *  跳转模式存储数据
     * @param {String} func 函数名 
     * @param {Object} data 参数
     */
    set: (func, data) => {
        var searchCache = window.name || ""
        var arr = searchCache.split("!!")
        arr.push([
            func, JSON.stringify(data)
        ].join("--"))
        window.name = arr.join("!!")
    },
    /**
     * 跳转模式拿取数据
     */
    get: () => {
        var searchCache = window.name || ""
        if (!searchCache) {
            return
        }
        var searchData = searchCache.split("!!")
        for (var i = 0; i < searchData.length; i++) {
            var item = searchData[i].split("--")
            if (item[1]) {
                listener.setListen(item[0], JSON.parse(item[1]))
            } else {
                listener.setListen(item[0])
            }
        }
        window.name = ""
    }
}
/**
 * 特殊处理模块
 */
const special = {
    /**
     * 拉起客户端单曲页
     * @param {*} businessId 
     */
    launchListen: (businessId, launch, callback) => {
        let fn = () => {
            if (protectData.audioInfoData) {
                let data = protectData.audioInfoData
                var params = {
                    "filename": data.author_name + " - " + data.songname,
                    "filesize": data.audio_info.filesize,
                    "hash": data.audio_info.hash,
                    "bitrate": data.audio_info.bitrate,
                    "extname": data.audio_info.extname,
                    "duration": data.audio_info.timelength / 1000,
                    "m4afilesize": data.audio_info.filesize_128,
                    "320hash": data.audio_info.hash_320,
                    "320filesize": data.audio_info.filesize_320,
                    "isplay": 1,
                    "privilege": data.audio_info.privilege,
                    "cyt2": "open",
                    "pull_channel_id": businessId,
                    "mini_kg_plat": util.getPlat(businessId)
                }
                params['320size'] = params['320filesize'] || 0;
                params['size'] = params['filesize'] || 0;
                params['m4asize'] = params['m4afilesize'] || 0;
                params['timelength'] = params['duration'];
                params['320hash'] = params['320hash'] || 0;
                params['isplay'] = 1;
                openKugouApp(301, 1, 1, params, null, (success, type) => {
                    // if (type == "isWeChat") {
                    //     util.colle({
                    //         svar1: businessId,
                    //         svar2: success ? 117 : 118,
                    //         svar3: success ? "已安装尝试拉活" : "未安装尝试拦截客户端"
                    //     })
                    // }
                    if (type == "universalLinks" && success) {
                        util.colle({
                            svar1: businessId,
                            svar2: 127,
                            svar3: "通用链成功拉起"
                        })
                    }
                    if (!success) {
                        callback && callback();
                    }
                }, { aid: businessId, inPartnerApp: player.data.inPartnerApp });
                return true
            } else {
                callback && callback();
            }
        }
        if (launch) {
            return fn()
        } else {
            callback && callback();
        }
    },
    /**
     * 平台判断
     * @param {*} businessId 
     */
    platform: (businessId) => {
        if (businessId == "meipian") {
            if (!!/(ios|android){1} *\/ *(\d+\.\d+\.\d+){1}/.test(navigator.userAgent.toLocaleLowerCase())) {
                return "美篇客户端"
            }
        }
    },
    launchPC: () => {
        var data = protectData.audioInfoData
        if (data) {
            util.loadScript('https://staticssl.kugou.com/public/root/javascripts/jslib/base64.min_4d995f331b.js', "", function () {
                var filename = data.author_name + " - " + data.songname;
                filename = filename.length > 58 ? filename.substring(0, 58) + "..." : filename;
                var launchData = {
                    Files: [
                        {
                            filename: filename + ".mp3",
                            hash: data.audio_info.hash,
                            size: data.audio_info.filesize,
                            duration: data.audio_info.timelength,
                            bitrate: data.audio_info.bitrate,
                            isfilehead: data.audio_info.is_file_head,
                            privilege: data.audio_info.privilege,
                        }
                    ]
                }
                var url = 'kugou://play?p=' + Base64.encode(JSON.stringify(launchData));
                var ua = util.getUA()
                if (ua.isIE(6) || ua.isIE(7) || ua.isIE(8)) {
                    window.open(url)
                } else {
                    var ifr = document.getElementById("launchPC")
                    if (!ifr) {
                        ifr = document.createElement("iframe")
                        ifr.style.cssText = [
                            "width:0",
                            "height:0",
                            "display:none"
                        ]
                        ifr.src = url
                        ifr.id = "launchPC"
                        document.body.appendChild(ifr)
                    }
                    ifr.src = url;
                }
            })
            setTimeout(() => {
                player.pause()
                window.open("http://download.kugou.com/");
            }, 500)
        }
    }
}

setTimeout(() => { search.get() }, 1000)
util.wxLoad(() => {
    util.loadScript(domain + "/static/js/collect-2400.js")
    if (navigator.userAgent.toLocaleLowerCase().match(/iphone|ipad|ios/i)) {
        playerManager.play()
    }
})
export default {
    player: player,
    search: search,
    listener: listener,
    bar: ui,
    tool: tool
}